import { FormConfig } from '@frontend/design-system';
import { dropdownField, switchField, textField } from '../../utils/field-config-helpers';

export type WebToTextFieldTypes = typeof webToToTextConfig;

export const webToToTextConfig = {
  enableWebToText: switchField(),
  previewMessage: textField(),
  firstMessageSentToUser: textField(),
  clinicName: textField(),
  assistantName: textField(),
  defaultState: dropdownField(),
  brandColorPicker: textField(),
  logoUrl: textField(),
} satisfies FormConfig;
